module.exports = __webpack_public_path__ + "img/filter.e87b2e08.svg";